import Icon from "@mdi/react";
import { mdiAccountGroup, mdiCalendar, mdiVote } from "@mdi/js";
import { Link } from "easy-page-router/react";
import { useLang } from "../services/lang";

export function OtherPolls({ what, who, when }: { what?: boolean, who?: boolean, when?: boolean }) {
    const { dict } = useLang();

    return <div className="other-polls">
        <b>{dict.pollOther}</b>
        <div>
            {what && <Link className="block other-poll-what" href={`/${dict.urlPoll}`}>
                {dict.pollWhat}
                <Icon path={mdiVote} size={1} />
            </Link>}
            {who && <Link className="block other-poll-who" href={`/${dict.urlWho}`}>
                {dict.pollWho}
                <Icon path={mdiAccountGroup} size={1} />
            </Link>}
            {when && <Link className="block other-poll-when" href={`/${dict.urlWhen}`}>
                {dict.pollWhen}
                <Icon path={mdiCalendar} size={1} />
            </Link>}
        </div>
    </div>;
}
